import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PanelRedeemInfo_CouponStamp from '../../../components/panel/non-payment-registration/PanelRedeemInfo_CouponStamp.js';
import CollapsibleDiv from '../../../components/shared/CollapsibleDiv.js';
import ImageTitle from '../../../components/shared/ImageTitle.js';
import '../../../css/Stamp.css';
import { useSearchParams, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';

function CouponStamp(props) {
  console.log(process.env.REACT_APP_ENV);
  const navigate = useNavigate();
  const location = useLocation(); // Captures the route they tried to visit

  const PUBLIC_URL = process.env.PUBLIC_URL;
  const eventName = window.name;
  const url = new URL(window.location.href);
  let baseUrl = `${url.protocol}//${url.host}/`;

  let bgcolor_shop = '';
  let usedCouponShop = '';

  if (process.env.REACT_APP_API_URL != '') {
    baseUrl = process.env.REACT_APP_API_URL;
  }

  const [searchParams, setSearchParams] = useSearchParams();

  const bgColor = process.env.REACT_APP_BG_COLOR;
  const stampUrl = baseUrl + 'frontend/api/NPEnroll/GetStampInfo';
  const trackingUrl = baseUrl + 'frontend/api/Enroll/InsertTrackingChannel';

  const pickupIconUrl = process.env.REACT_APP_URL_IMAGE + 'stamp_icon.png';
  const [itemDetails, setItemDetails] = useState([]);
  const [content, setContent] = useState({
    Event_PromoName: '',
    Event_Url_Name: '',
    Geocode: '',
    Mobile: '',
    Pickup_Location: '',
    Pickup_Adress: '',
    Invoice_no: '',
    Stamp_TnC: '',
    Stamp_Picture: '',
    Stamp_QRCode_Icon: '',
    Stamp_Code: '',
    Stamp_Start_Date: '',
    Stamp_End_Date: '',
    Stamp_Pickup_Method: '',
    Stamp_Prefix: '',
    Event_Version: '',
  });

  if (props.isdebugmode) console.log(baseUrl);

  const formatDate = (date) => {
    const formattedDate = new Date(date)
      .toLocaleDateString('en-HK', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(/(\d+)\/(\d+)\/(\d+)/, '$3-$2-$1');
    return formattedDate;
  };

  const myDate = new Date();
  const formattedTDY = formatDate(myDate);

  if (props.isdebugmode) console.log(formattedTDY);

  //Specific pop up shop
  const currentLoc_Id = searchParams.get('int_loc_id');

  const popupShop = ['20203', '20208', '20207', '20204', '20209', '20210', '20211', '20212', '20213', '20214', '20202','20040'];

  if (!popupShop.includes(currentLoc_Id)) {
    navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
  }

  switch (currentLoc_Id) {
    case '20203':
      bgcolor_shop = 'yellow';
      usedCouponShop = '上水主店(上水廣場)';
      break;
    case '20208':
      bgcolor_shop = 'lightgreen';
      usedCouponShop = '屯門主店(卓爾廣場)';
      break;
    case '20207':
      bgcolor_shop = 'orange';
      usedCouponShop = '油塘主店 或 將軍澳主店';
      break;
    case '20204':
      bgcolor_shop = 'MediumSeaGreen';
      usedCouponShop = '佐敦主店(鴻運大樓)';
      break;
    case '20209':
      bgcolor_shop = 'red';
      usedCouponShop = '旺角主店銀行中心廣場4樓 (旺角站E2出口側)';
      break;
    case '20210':
      bgcolor_shop = 'MediumPurple';
      usedCouponShop = '銅鑼灣主店';
      break;
    case '20211':
      bgcolor_shop = 'LightSkyBlue';
      usedCouponShop = '青衣主店 或 旺角主店銀行中心廣場4樓 (旺角站E2出口側)';
      break;
    case '20212':
      bgcolor_shop = 'turquoise';
      usedCouponShop = '長沙灣主店';
      break;
    case '20213':
      bgcolor_shop = 'royalblue';
      usedCouponShop = '沙田主店';
      break;
    case '20214':
      bgcolor_shop = 'lightGrey';
      usedCouponShop = '黃大仙主店';
      break;
    case '20202':
      bgcolor_shop = 'pink';
      usedCouponShop = '尖沙咀主店';
      break;
    case '20040':
      bgcolor_shop = 'orange';
      usedCouponShop = '啟德招牌店';
      break;
    default:
      bgcolor_shop = 'orange';
      usedCouponShop = 'NA';
      break;
  }

  const toPreviousEvent = async () => {
    const datePart = eventName.substring(0, 8);
    //console.log(dayjs().format('YYYY-MM-DD HH:mm:ss'));

    const eventDate = dayjs(datePart, 'YYYYMMDD');
    const previousEventName = eventDate.subtract(14, 'days').format('YYYYMMDD') + eventName.substring(8);

    if (dayjs().isBefore(eventDate.subtract(4, 'hour')) && dayjs().day() === 3 && location.state === null) {
      const PreviousEventUrl = `../../../${PUBLIC_URL}/${previousEventName}/CouponStamp?int_loc_id=${currentLoc_Id}`;
      return PreviousEventUrl;
    }
    return '';
  };

  const checkEventStatus = async () => {
    const checkEventStatusUrl = new URL('frontend/api/NPEnroll/CheckEventStatus', baseUrl);
    checkEventStatusUrl.search = new URLSearchParams({
      Event_Name: eventName,
    });

    const response = await fetch(checkEventStatusUrl.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json(); //{ IsSuccess: true/false, ErrorCode: 10018 if event is not effective yet }
    if (props.isdebugmode) console.log(result);
    if (result.IsSuccess == false && result.ErrorCode == 10018) {
      navigate('../../../' + PUBLIC_URL + '/' + eventName + '/event-not-effective');
      return result.IsSuccess; //false
    }

    return result.IsSuccess; //true
  };

  useEffect(() => {
    const init = async () => {
      try {
        if (props.isdebugmode) console.log('currentLoc_Id: ' + currentLoc_Id);
        const response = await fetch(stampUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Event_Name: eventName,
            SMS_Code: formattedTDY, //props.code //pass TDY
          }),
        });

        const responseJson = await response.json();
        let result = JSON.parse(JSON.stringify(responseJson));
        if (props.isdebugmode) console.log(result);
        if (result.IsSuccess == null) {
          setContent((previousState) => {
            return {
              ...previousState,
              Event_PromoName: result.Event_PromoName,
              Event_Url_Name: result.Event_Url_Name,
              Geocode: result.Geocode,
              Mobile: result.Mobile,
              Pickup_Location: currentLoc_Id, //result.Pickup_Location,
              Pickup_Adress: formattedTDY >= '2026-04-03' ? '全線主店' : usedCouponShop, //result.Pickup_Adress,
              Invoice_no: result.Invoice_no,
              Stamp_TnC: result.Stamp_TnC,
              Stamp_Picture: result.Stamp_Picture,
              allTitle_FontColor: bgcolor_shop, //result.AllTitle_FontColor,
              Stamp_QRCode_Icon: result.Stamp_QRCode_Icon,
              Stamp_Code: result.Stamp_Code,
              Stamp_Start_Date: result.Stamp_Start_Date,
              Stamp_End_Date: result.Stamp_End_Date,
              Stamp_Pickup_Method: result.Stamp_Pickup_Method,
              Stamp_Prefix: result.Stamp_Prefix,
              Event_Version: result.Event_Version,
            };
          });

          // Redirect to enroll page if it is not non-payment event
          if (result.Event_Version != 3) {
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }

          let items = [];
          for (let i = 0; i < result.Item_Detail.length; i++) {
            items.push(result.Item_Detail[i]);
          }
          setItemDetails(items);
        } else {
          navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
        }
      } catch (err) {
        //navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-error');
        if (props.isdebugmode) console.log(err);
      }

      try {
        const trackingResponse = await fetch(trackingUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            event_Name: eventName,
            source: currentLoc_Id, //track from shop url
          }),
        });
        await trackingResponse.json();
      } catch (err) {
        if (props.isdebugmode) console.log(err);
      }
    };

    const checkEvent = async () => {
      try {
        const prevEventUrl = await toPreviousEvent();
        if (prevEventUrl === '') {
          const checkStatusResult = await checkEventStatus();
          if (checkStatusResult) {
            await init();
          }
        } else {
          navigate(prevEventUrl, {
            state: { from: location.pathname },
          });
        }
      } catch (err) {
        if (props.isdebugmode) console.log(err);
        navigate('../../../' + PUBLIC_URL + '/fail-wrong-url');
      }
    };
    checkEvent();
  }, [location]);

  let stampPickup = "<div className='pickup-logo'><img src='" + pickupIconUrl + "'/>請向店員出示本電子印花</div>";

  return (
    <>
      <Form>
        {content.Stamp_Picture !== '' && (
          <div className='d-grid'>
            <ImageTitle src={content.Stamp_Picture} alt='logo' />
            <div style={{ backgroundColor: bgColor }}>
              <PanelRedeemInfo_CouponStamp data={content} stock={itemDetails}></PanelRedeemInfo_CouponStamp>
            </div>
            <CollapsibleDiv title='電子印花使用方法' content={{ __html: stampPickup }}></CollapsibleDiv>
            <CollapsibleDiv title='使用條款及細則' content={{ __html: content.Stamp_TnC }}></CollapsibleDiv>
          </div>
        )}
      </Form>
    </>
  );
}

export default CouponStamp;
